import {useCallback, useState} from "react";
import {updateAutoCheckInConfig} from "./api";
import {AutoCheckInConfigUpdateRequest} from "./types";

export function useUpdateCheckInConfig(profileID: string | undefined, refetchProfiles: () => void) {

    const [error, setError] = useState<string>()
    const [message, setMessage] = useState<string>()
    const [name, setName] = useState("")
    const [submitting, setSubmitting] = useState<boolean>()

    const submit = useCallback(async (request: AutoCheckInConfigUpdateRequest) => {
        setMessage(undefined)
        if(!profileID){
            setError("no profile selected")
            return
        }
        setError(undefined)
        setSubmitting(true)

        const result = await updateAutoCheckInConfig(profileID, request)

        result.match(
            () => {
                setMessage("profile updated")
                refetchProfiles()
            },
            (err) => setError(err.message)
        )

        setSubmitting(false)
    }, [profileID, refetchProfiles])

    return {submit, submitting, error, name, setName, message}

}